<template>
    <div>
        <sui-form-field v-for="(item, itemIndex) in input" :key="itemIndex">
            <div class="ui fluid action input">
                <input type="text" v-model="input[itemIndex]" @input="onChange">
                <sui-button color="red" @click="onRemoveItem(input, itemIndex)">Remove</sui-button>
            </div>
        </sui-form-field>

        <sui-form-field>
            <sui-button fluid @click="onAddItem(input, '')">Add</sui-button>
        </sui-form-field>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            input: this.value || [],
        };
    },
    watch: {
        value: {
            handler(value) {
                this.input = value || [];
            },
            immediate: true,
        }
    },
    methods: {
        onChange() {
            this.$emit('input', this.input);
        },
        onAddItem(array, value) {
            array.push(value);
            this.onChange();
        },
        onRemoveItem(array, index) {
            array.splice(index, 1);
            this.onChange();
        },
    }
}
</script>